import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-item-travel-fuel-supplier-cards.component.scss';
import * as $ from "jquery";
import "bootstrap-datepicker";
var FormItemTravelFuelSupplierCards = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemTravelFuelSupplierCards, _super);
    function FormItemTravelFuelSupplierCards(element) {
        return _super.call(this, element) || this;
    }
    FormItemTravelFuelSupplierCards.prototype.init = function () {
        this.form = this.element.querySelector("form");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        this.formDatePicker = this.element.querySelector(".js-date-picker");
        this.formTimePicker = this.element.querySelector(".js-time-picker");
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
        //calender
        this.publicHolidays = [
            "2018/01/01",
            "2018/03/21",
            "2018/03/30",
            "2018/04/02",
            "2018/04/27",
            "2018/05/01",
            "2018/06/16",
            "2018/08/09",
            "2018/09/24",
            "2018/12/16",
            "2018/12/17",
            "2018/12/25",
            "2018/12/26",
        ];
        this.populateDatePicker();
    };
    // populating the current date picker
    FormItemTravelFuelSupplierCards.prototype.populateDatePicker = function () {
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker("setStartDate", this._startDate);
        }
    };
    FormItemTravelFuelSupplierCards.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ""; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== "") {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() +
                "/" +
                _selectedDate.getMonth() +
                "/" +
                _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() +
                "/" +
                _currentDateTime.getMonth() +
                "/" +
                _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if (_currentMin >= 30 && _currentHour <= 15) {
            _currentHour++;
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentMin >= 30 && _currentHour >= 15) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() +
            "/" +
            ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate =
                        _currentDateTime.getFullYear() +
                            "/" +
                            ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) +
                            "/" +
                            ("0" + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = _currentHour >= 10
            ? _currentHour + ":00:00"
            : "0" + _currentHour + ":00:00";
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== "Anytime") {
                if (item.options[i].value < _tmpTime &&
                    _enabledOptions === false) {
                    item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    FormItemTravelFuelSupplierCards.prototype.bindEvents = function () {
        var _this = this;
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".js_business-reg");
        if (businessReg) {
            businessReg.addEventListener("input", function (event) {
                if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        //Calender
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener("change", function (event) {
                _this.validateDate(event.target);
            });
        }
        //Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm("done"); });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm("close"); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
            _this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute('hidden');
            _this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsShowBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute('hidden');
            _this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailShowBtn.removeAttribute('hidden');
        });
    };
    FormItemTravelFuelSupplierCards.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
            window.location.href = this.closeButton.getAttribute('data-url');
        }
        else {
            window.location.href = this.doneSubmit.getAttribute('data-url');
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
    };
    FormItemTravelFuelSupplierCards.prototype.submitForm = function (form) {
        var _this = this;
        var _email = this.form.querySelector("input[name=email]");
        var _recipient = this.form.querySelector("input[name=recipient]");
        var _subject = this.form.querySelector("input[name=subject]");
        var _product = this.form.querySelector("input[name=product]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _contact = this.form.querySelector("input[name=contact-number]");
        var _busName = this.form.querySelector("input[name=business-name]");
        var _busRegNumber = this.form.querySelector("input[name=business-reg-number]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _dateTime = "Anytime";
        if (_date && _time) {
            //if (_time.value !== `Anytime`) {
            _dateTime = _date.value + " " + _time.value;
            //}
        }
        var _postData = {
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'surname': (_lastName ? _lastName.value : ""),
            'contactNumber': (_contact ? _contact.value : ""),
            'businessName': (_busName ? _busName.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'businessRegNumber': (_busRegNumber ? _busRegNumber.value : ""),
            'popiConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dateTime': _dateTime,
            'dataPrivacyConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.getDataConsentValue(form, 'data-sharing-email'),
            'dataSharingSms': this.getDataConsentValue(form, 'data-sharing-sms'),
            'dataSharingInApp': 'YES'
        };
        this.showDisplayView("loader");
        // service
        var url = this.baseUrl + "/leadsutils/save-company-card-lead";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            if (response.data.includes("invalid")) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.dtmVirtualPage('thank you');
                _this.analyticsService.dtmFormComplete("complete", "200");
                _this.showDisplayView("success");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemTravelFuelSupplierCards.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemTravelFuelSupplierCards.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    FormItemTravelFuelSupplierCards.prototype.dtmVirtualPage = function (pPageNameNew) {
        var urlPath = window.location.pathname;
        var urlSegments = urlPath.split('/');
        var extractedKey = urlSegments[urlSegments.length - 1];
        var pageMapping = {
            'travel-card-form': 'business:products and services:bank with us:company cards:our cards:travel card success thank you',
            'forex-card-form': 'business:products and services:bank with us:company cards:our cards:forex card success thank you',
            'corporate-charge-card-form': 'business:products and services:bank with us:company cards:our cards:corporate charge card success thank you',
            'aviation-card-form': 'business:products and services:bank with us:company cards:our cards:aviation card success thank you',
            'procurement-card-form': 'business:products and services:bank with us:company cards:our cards:procurement card success thank you',
        };
        var taggingValue = pPageNameNew === 'thank you'
            ? pageMapping[extractedKey] || 'business:products and services:bank with us:company cards:default success thank you'
            : "business:products and services:bank-with-us:company-cards:business-credit-card-form:" + pPageNameNew;
        dataLayer.pageName = taggingValue;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    return FormItemTravelFuelSupplierCards;
}(Base));
export { FormItemTravelFuelSupplierCards };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-travel-fuel-supplier-cards/form-item-travel-fuel-supplier-cards.component.ts
// module id = 1051
// module chunks = 0